export const DOSEMETER_TYPE_ENVIRONMENTAL = 1;
export const DOSEMETER_TYPE_PERSONAL = 2;
export const DOSEMETER_TYPE_PERSONAL_WRIST = 3;

export const getDosemeterTypeDescription = (type, translations) => {
  switch (type) {
    case DOSEMETER_TYPE_ENVIRONMENTAL:
      return `S - ${translations.dosemeterTypeEnvironmental}`;
    case DOSEMETER_TYPE_PERSONAL:
      return `I - ${translations.dosemeterTypePersonal}`;
    case DOSEMETER_TYPE_PERSONAL_WRIST:
      return `N - ${translations.dosemeterTypePersonalWrist}`;
    default:
      return `U - ${translations.statusUnknown}`;
  }
}

export const getDosemeterTypeCode = type => {
  switch (type) {
    case DOSEMETER_TYPE_ENVIRONMENTAL:
      return 'S';
    case DOSEMETER_TYPE_PERSONAL:
      return 'I';
    case DOSEMETER_TYPE_PERSONAL_WRIST:
      return 'N';
    default:
      return 'U';
  }
}
